/**
 * Where a replay starts: the first move made since you last looked at the game (`seenVersion`), or, when you've seen
 * them all, the latest move (step back from there).
 *
 * @param {{ version: number, turn: number }[]} entries the moves, oldest first
 * @param {?number} seenVersion the game's version when you last looked, if known
 * @returns {number} an index into entries
 */
export function replayStart(entries, seenVersion) {
  if (!entries.length) {
    return 0;
  }
  if (seenVersion !== null && seenVersion !== undefined) {
    const unseen = entries.findIndex(entry => entry.version > seenVersion);
    if (unseen !== -1) {
      return unseen;
    }
  }
  return entries.length - 1;
}
